import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader";
import { css } from "styled-components";

headerStyles.invoiceCountGridItem = mergeToNew(headerStyles.invoiceCountGridItem, {
    width: 12,
});

headerStyles.toggleFilterGridItem = mergeToNew(headerStyles.toggleFilterGridItem, {
    width: 12,
    css: css`
        align-items: flex-end;
        justify-content: space-between;
        gap: 16px;
        margin-top: 24px;
        padding-top: 20px;
        .downloadIcon {
            > span {
                display: flex; 
            }
        }
    `,
});

headerStyles.toggleFilterButton = mergeToNew(headerStyles.toggleFilterButton, {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        gap: 8px;
        min-height: initial;
        color: ${themeColors.primary.richBlack};
        &,
        &:hover {
            border: none;
            background: transparent;
        }
    `,
});

headerStyles.titleText =  mergeToNew(headerStyles.titleText, {
    css: css`
        padding-left: 0;
    `,
});